import { useCreditsContext } from '../../context/CreditsContext';

export default function CreditToastContainer() {
  const { toasts, dismissToast } = useCreditsContext();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex flex-col gap-2 pointer-events-none">
      {toasts.map(toast => {
        const isDeduct = toast.type === 'deduct';
        const isAdd = toast.type === 'add';

        return (
          <div
            key={toast.id}
            className="pointer-events-auto flex items-center gap-3 px-4 py-3 rounded-2xl border shadow-lg min-w-[220px] max-w-xs animate-slide-in-right"
            style={{
              background: isDeduct ? '#1c1917' : isAdd ? '#052e16' : '#1c1917',
              borderColor: isDeduct ? '#78350f' : isAdd ? '#166534' : '#44403c',
            }}
          >
            {/* Icon */}
            <div
              className="w-8 h-8 flex items-center justify-center rounded-full shrink-0"
              style={{ background: isDeduct ? '#7c2d12' : isAdd ? '#14532d' : '#292524' }}
            >
              {isDeduct && <i className="ri-coin-line text-orange-400 text-sm" />}
              {isAdd && <i className="ri-add-circle-line text-emerald-400 text-sm" />}
              {toast.type === 'info' && <i className="ri-information-line text-stone-400 text-sm" />}
            </div>

            {/* Text */}
            <div className="flex-1 min-w-0">
              {toast.amount !== undefined && (
                <p className="text-xs font-extrabold leading-none mb-0.5" style={{ color: isDeduct ? '#fb923c' : '#4ade80' }}>
                  {isDeduct ? `−${toast.amount}` : `+${toast.amount}`} credits
                </p>
              )}
              <p className="text-xs text-stone-400 leading-snug">{toast.message}</p>
            </div>

            {/* Dismiss */}
            <button
              onClick={() => dismissToast(toast.id)}
              className="w-5 h-5 flex items-center justify-center text-stone-600 hover:text-stone-300 transition-colors cursor-pointer shrink-0"
            >
              <i className="ri-close-line text-sm" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
